/*
 * Ted, Tarpaulins UK's AI cover specialist.
 * Chat window (launcher bottom right) + "Questions about this product?" box on product pages.
 * The expert lives in the Cloudflare Worker (same one as Gym Flooring UK's Hugo; it picks Ted from
 * the page's origin). Replies stream in and are read aloud (British voice) unless the customer mutes.
 * Snippet: snippets/ted.liquid (sets data-ai on #tedPanel). Styles: assets/ted.css.
 */
(function () {
  'use strict';
  var panel = document.getElementById('tedPanel');
  if (!panel || window.TedChat) return;

  var AI_URL = panel.getAttribute('data-ai') || '';
  var BASE = AI_URL.replace(/\/chat\/?$/, '');
  var TTS_URL = BASE ? BASE + '/tts' : '';
  var STT_URL = BASE ? BASE + '/stt' : '';
  var PHONE = '01744 520 110', TEL = 'tel:01744520110';
  var WA = 'https://wa.me/447822012977?text=' + encodeURIComponent('Hi, I need help choosing a tarpaulin');
  var EMAIL = 'sales@tarpaulinsuk.uk';
  var TEAM = 'Call <a href="' + TEL + '">' + PHONE + '</a>, <a href="' + WA + '" target="_blank" rel="nofollow noopener">WhatsApp us</a> or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> (Mon-Fri 9am-5pm).';
  var STORE_KEY = 'ted_state_v1', VOICE_KEY = 'ted_voice_v1';

  var launch = document.getElementById('tedLaunch');
  var log = document.getElementById('tedLog');
  var chips = document.getElementById('tedChips');
  var form = document.getElementById('tedForm');
  var input = document.getElementById('tedInput');
  var voiceBtn = document.getElementById('tedVoice');
  var statusEl = document.getElementById('tedStatus');

  var convo = [], history = [], busy = false;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(pence) { return '\u00A3' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function track(action, source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'tu_specialist', tu_action: action, tu_source: source || 'unknown' }); } catch (e) {}
  }

  // ---------- Markdown-lite rendering (same rules as Hugo) ----------
  function renderMd(src) {
    var lines = esc(src).split('\n'), out = '', list = '';
    function closeList() { if (list) { out += '</' + list + '>'; list = ''; } }
    lines.forEach(function (ln) {
      var m;
      if ((m = ln.match(/^\s*[-\u2022*]\s+(.*)$/))) { if (list !== 'ul') { closeList(); out += '<ul>'; list = 'ul'; } out += '<li>' + m[1] + '</li>'; return; }
      if ((m = ln.match(/^\s*\d+[.)]\s+(.*)$/))) { if (list !== 'ol') { closeList(); out += '<ol>'; list = 'ol'; } out += '<li>' + m[1] + '</li>'; return; }
      closeList();
      if (ln.trim()) out += '<p>' + ln + '</p>';
    });
    closeList();
    return out.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>').replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (all, t, u) {
      var href = u.replace(/&amp;/g, '&');
      var ok = /^\/(?!\/)/.test(href) || /^https:\/\/(www\.)?tarpaulinsuk\.uk\//.test(href) || /^tel:|^mailto:sales@tarpaulinsuk\.uk$|^https:\/\/wa\.me\/447822012977/.test(href);
      if (!ok) return t;
      var ext = /^https:\/\/wa\.me/.test(href);
      return '<a href="' + esc(href) + '"' + (ext ? ' target="_blank" rel="nofollow noopener"' : '') + '>' + t + '</a>';
    });
  }
  function visibleText(full) { return full.replace(/\[\[[^\]]*\]\]/g, '').replace(/\[\[[^\]]*$/, '').trim(); }

  // ---------- Product cards and quotes (filled in after the reply renders) ----------
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[handle];
  }
  function getVariants(ids) {
    if (!BASE || !ids.length) return Promise.resolve({});
    return fetch(BASE + '/variant?ids=' + ids.join(','), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : { variants: {} }; })
      .then(function (j) { return j.variants || {}; })
      .catch(function () { return {}; });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function cardHtml(p) {
    var price = p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price_min);
    var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ted-card__ph"></span>';
    return '<div class="ted-card">' + img + '<div class="ted-card__body"><div class="ted-card__name">' + esc(p.title) +
      '</div><div class="ted-card__price">' + price + '</div><a class="ted-card__link" href="/products/' + esc(p.handle) + '">View product</a></div></div>';
  }
  function quoteHtml(id, qty, v) {
    qty = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
    if (!v) return '';
    var opt = v.title && v.title !== 'Default Title' ? '<div><span>Size / option</span><b>' + esc(v.title) + '</b></div>' : '';
    var btn = v.available ? '<button type="button" class="ted-add" data-v="' + esc(id) + '" data-q="' + qty + '">Add ' + qty + ' to basket</button>'
      : '<small>This option is currently unavailable online; please call us.</small>';
    return '<div class="ted-quote"><div><span>Product</span><b><a href="/products/' + esc(v.handle) + '?variant=' + esc(id) + '">' + esc(v.product) + '</a></b></div>' + opt +
      '<div><span>Quantity</span><b>' + qty + ' x ' + money(v.price) + '</b></div><div><span>Total</span><b>' + money(v.price * qty) + '</b></div>' +
      '<small>Inc. VAT. Sizes are cut sizes; the finished sheet is slightly smaller.</small>' + btn + '</div>';
  }
  // Turns the reply's [[...]] tags into placeholders, returns html + chips + async fill job.
  function renderReply(text, holder) {
    var chipList = null, note = '', products = [], quotes = [];
    var body = text.replace(/\[\[(product|quote|chips|refusal|error)(?::([^\]]*))?\]\]/g, function (all, kind, arg) {
      arg = arg || '';
      if (kind === 'product') products.push(arg.trim());
      else if (kind === 'quote') { var b = arg.split(':'); if (/^\d+$/.test(b[0])) quotes.push({ id: b[0], q: b[1] }); }
      else if (kind === 'chips') chipList = arg.split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
      else note = "Sorry, I can't help with that one here. Our team can: " + TEAM;
      return '';
    });
    holder.innerHTML = renderMd(body.replace(/\[\[[^\]]*$/, '').trim()) + (note ? '<p>' + note + '</p>' : '') + '<div class="ted-extras"></div>';
    var extras = holder.querySelector('.ted-extras');
    var jobs = [];
    products.forEach(function (h) {
      var slot = document.createElement('div'); extras.appendChild(slot);
      jobs.push(getProduct(h).then(function (p) { slot.outerHTML = cardHtml(p); }).catch(function () { slot.remove(); }));
    });
    if (quotes.length) {
      var qslots = quotes.map(function () { var s = document.createElement('div'); extras.appendChild(s); return s; });
      jobs.push(getVariants(quotes.map(function (q) { return q.id; })).then(function (vs) {
        quotes.forEach(function (q, i) { var h = quoteHtml(q.id, q.q, vs[q.id]); if (h) qslots[i].outerHTML = h; else qslots[i].remove(); });
      }));
    }
    return { chips: chipList, done: Promise.all(jobs) };
  }

  function addToCart(btn) {
    var id = +btn.getAttribute('data-v'), q = +btn.getAttribute('data-q');
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: q }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); btn.textContent = 'Added, going to basket...'; save(); track('add_to_cart', 'ted'); window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  // ---------- Speech: numbers and sizes the way a person says them ----------
  var ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  function words(n) {
    n = Math.floor(n);
    if (n < 20) return ONES[n];
    if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? '-' + ONES[n % 10] : '');
    if (n < 1000) return ONES[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + words(n % 100) : '');
    if (n < 1e6) { var r = n % 1000; return words(Math.floor(n / 1000)) + ' thousand' + (r ? (r < 100 ? ' and ' : ' ') + words(r) : ''); }
    return String(n);
  }
  function numWords(s) {
    s = String(s).replace(/,/g, '');
    var p = s.split('.'), w = words(parseInt(p[0], 10) || 0);
    if (p[1]) w += ' point ' + p[1].split('').map(function (d) { return ONES[+d]; }).join(' ');
    return w;
  }
  var UNIT = { mm: 'millimetres', cm: 'centimetres', m: 'metres', ft: 'feet', kg: 'kilos', gsm: 'g s m', oz: 'ounce' };
  var NUM = '(\\d[\\d,]*(?:\\.\\d+)?)';
  function spoken(text) {
    var t = String(text).replace(/\[\[[^\]]*\]\]/g, ' ').replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/\*\*/g, '').replace(/^\s*[-\u2022*]\s+/gm, '');
    t = t.replace(/\b0\d{3,4}[\s-]?\d{3}[\s-]?\d{3,4}\b/g, function (m) {
      return m.split(/[\s-]+/).map(function (g) { return g.split('').map(function (d) { return d === '0' ? 'oh' : ONES[+d]; }).join(' '); }).join(', ');
    });
    t = t.replace(/\u00A3(\d[\d,]*)(?:\.(\d\d))?/g, function (m, p, d) {
      var n = parseInt(p.replace(/,/g, ''), 10);
      return words(n) + (n === 1 ? ' pound' : ' pounds') + (d && d !== '00' ? ' ' + words(+d) : '');
    });
    t = t.replace(new RegExp(NUM + '\\s*m\u00B2', 'g'), function (m, n) { return numWords(n) + (parseFloat(n) === 1 ? ' square metre' : ' square metres'); });
    // 4m x 6m, 4 x 6m, 12ft x 18ft
    t = t.replace(new RegExp(NUM + '\\s*(m|ft|cm)?\\s*[x\u00D7]\\s*' + NUM + '\\s*(m|ft|cm)?\\b', 'g'), function (m, a, ua, b, ub) {
      var u = ub || ua;
      return numWords(a) + ' by ' + numWords(b) + (u ? ' ' + UNIT[u] : '');
    });
    t = t.replace(new RegExp(NUM + '\\s*(gsm|mm|cm|kg|oz|ft|m)\\b', 'g'), function (m, n, u) { return numWords(n) + ' ' + UNIT[u]; });
    t = t.replace(new RegExp(NUM + '\\s*%', 'g'), function (m, n) { return numWords(n) + ' percent'; });
    t = t.replace(new RegExp(NUM + '\\s*(?:-|\u2013)\\s*' + NUM, 'g'), function (m, a, b) { return numWords(a) + ' to ' + numWords(b); });
    t = t.replace(new RegExp(NUM, 'g'), function (m, n) { return numWords(n); });
    return t.replace(/\s+/g, ' ').trim();
  }
  function chunkText(text, max) {
    var parts = spoken(text).match(/[^.!?]+[.!?]*\s*/g) || [], out = [], cur = '';
    parts.forEach(function (p) { if ((cur + p).length > max && cur) { out.push(cur.trim()); cur = ''; } cur += p; });
    if (cur.trim()) out.push(cur.trim());
    return out;
  }

  // ---------- Voice out (Cloudflare TTS, British male voice; device voice as fallback) ----------
  var voiceOn = true, audioEl = null, playSeq = 0, audioUnlocked = false;
  var SILENT_WAV = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
  try { voiceOn = localStorage.getItem(VOICE_KEY) !== '0'; } catch (e) {}
  function ensureAudio() { if (!audioEl) { audioEl = new Audio(); audioEl.preload = 'auto'; } return audioEl; }
  function unlockAudio() {
    if (audioUnlocked || !voiceOn || !TTS_URL) return;
    var a = ensureAudio(); a.src = SILENT_WAV;
    var p = a.play();
    if (p && p.then) p.then(function () { audioUnlocked = true; }, function () {}); else audioUnlocked = true;
  }
  function stopVoice() {
    playSeq++;
    if (audioEl && String(audioEl.src).indexOf('data:') !== 0) { try { audioEl.pause(); } catch (e) {} }
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  }
  function speakDevice(text) {
    if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) return;
    var synth = window.speechSynthesis, vs = synth.getVoices() || [];
    var gb = vs.filter(function (v) { return /en[-_]GB/i.test(v.lang); });
    var voice = gb.filter(function (v) { return /male|Ryan|Thomas|George|Daniel|Arthur|Oliver|Google UK English Male/i.test(v.name); })[0] || gb[0] || null;
    synth.cancel();
    chunkText(text, 220).forEach(function (c) {
      var u = new SpeechSynthesisUtterance(c); u.lang = 'en-GB'; if (voice) u.voice = voice; u.rate = 1.02; u.pitch = 0.95; synth.speak(u);
    });
  }
  function say(text) { if (!voiceOn || !text) return; stopVoice(); if (!TTS_URL) return speakDevice(text); var s = startStream(); s.feed(text, true); }
  // Speaks a reply while it streams: each finished sentence is queued and played in order.
  function startStream() {
    stopVoice();
    var seq = playSeq, a = ensureAudio(), queue = [], playing = false, taken = 0;
    function playNext() {
      if (seq !== playSeq) return;
      var src = queue.shift();
      if (!src) { playing = false; return; }
      playing = true;
      var moved = false;
      function advance() { if (!moved) { moved = true; playNext(); } }
      a.onended = advance; a.onerror = advance; a.src = src;
      var pr = a.play(); if (pr && pr.catch) pr.catch(advance);
    }
    function enqueue(chunk) {
      chunkText(chunk, 600).forEach(function (t) { if (t) queue.push(TTS_URL + '?t=' + encodeURIComponent(t)); });
      if (!playing) playNext();
    }
    return {
      feed: function (visible, final) {
        if (seq !== playSeq || !voiceOn) return;
        var rest = visible.slice(taken);
        if (!rest.trim()) return;
        var cut = 0;
        if (final) cut = rest.length;
        else {
          var min = taken === 0 ? 30 : 140, re = /[.!?:](?=\s)|\n/g, m;
          while ((m = re.exec(rest))) { var end = m.index + 1; if (end > 600) break; if (end >= min) { cut = end; if (taken === 0) break; } }
        }
        if (cut > 0) { enqueue(rest.slice(0, cut)); taken += cut; }
      }
    };
  }
  function setVoice(on, fromClick) {
    voiceOn = !!on;
    try { localStorage.setItem(VOICE_KEY, voiceOn ? '1' : '0'); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-ted-voice]'), function (b) {
      b.setAttribute('aria-pressed', voiceOn ? 'true' : 'false');
      b.textContent = voiceOn ? 'Voice on' : 'Voice off';
      b.title = voiceOn ? 'Tap to mute Ted' : "Tap to hear Ted's answers";
    });
    if (!voiceOn) { stopVoice(); return; }
    if (fromClick) { audioUnlocked = false; unlockAudio(); say("Voice is on. Tell me what you're covering and I'll talk you through it."); track('voice_on', fromClick); }
  }

  // ---------- Voice in (mic -> /stt). Waits for real speech and a proper pause before sending. ----------
  var rec = null;
  function micSupported() { return !!(STT_URL && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder); }
  var MIC_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';
  function micButton() { return micSupported() ? '<button type="button" class="ted-mic" aria-label="Speak your question" title="Tap and speak">' + MIC_SVG + '</button>' : ''; }
  function pickMime() {
    var c = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
    for (var i = 0; i < c.length; i++) if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(c[i])) return c[i];
    return '';
  }
  function note(inp, msg) {
    var ph = inp.getAttribute('data-ph') || inp.placeholder;
    inp.setAttribute('data-ph', ph); inp.value = ''; inp.placeholder = msg;
    clearTimeout(inp._phT);
    if (msg !== ph) inp._phT = setTimeout(function () { inp.placeholder = ph; }, 5000);
  }
  function startMic(f) {
    var inp = f.querySelector('input'), btn = f.querySelector('.ted-mic');
    if (rec) { stopMic(); return; }
    stopVoice();
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } }).then(function (stream) {
      var mime = pickMime(), mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      rec = { mr: mr, stream: stream, chunks: [], form: f, input: inp, btn: btn };
      mr.ondataavailable = function (e) { if (e.data && e.data.size) rec.chunks.push(e.data); };
      mr.onstop = finishMic;
      mr.start();
      btn.classList.add('is-rec'); btn.setAttribute('aria-label', 'Stop listening');
      note(inp, 'Listening\u2026 just speak, then pause');
      try {
        var AC = window.AudioContext || window.webkitAudioContext, ac = new AC(), an = ac.createAnalyser();
        an.fftSize = 1024; ac.createMediaStreamSource(stream).connect(an); rec.ac = ac;
        var data = new Uint8Array(an.fftSize), heard = false, started = Date.now(), quietSince = started, voiced = 0, last = started;
        (function loop() {
          if (!rec || rec.mr !== mr) return;
          an.getByteTimeDomainData(data);
          for (var sum = 0, i = 0; i < data.length; i++) { var v = (data[i] - 128) / 128; sum += v * v; }
          var now = Date.now();
          if (Math.sqrt(sum / data.length) > 0.04) { voiced += now - last; quietSince = now; }
          last = now;
          if (voiced >= 250) heard = true;
          if (!heard && now - started > 10000) { rec.silent = true; stopMic(); return; }
          if ((heard && now - quietSince > 2200) || now - started > 30000) { stopMic(); return; }
          requestAnimationFrame(loop);
        })();
      } catch (e) { rec.timer = setTimeout(stopMic, 15000); }
    }).catch(function () { note(inp, 'Microphone blocked. Allow it in your browser, or type your question'); });
  }
  function stopMic() { if (rec) { try { if (rec.mr.state !== 'inactive') rec.mr.stop(); } catch (e) {} } }
  function finishMic() {
    var r = rec; rec = null; if (!r) return;
    r.stream.getTracks().forEach(function (t) { t.stop(); });
    if (r.ac) { try { r.ac.close(); } catch (e) {} }
    clearTimeout(r.timer);
    r.btn.classList.remove('is-rec'); r.btn.setAttribute('aria-label', 'Speak your question');
    if (r.silent) { r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; return; }
    r.btn.classList.add('is-busy'); note(r.input, 'Got it, one moment\u2026');
    var blob = new Blob(r.chunks, { type: r.mr.mimeType || 'audio/webm' });
    function done(text) {
      r.btn.classList.remove('is-busy');
      if (text === null) { note(r.input, "Sorry, I couldn't make that out. Could you type it?"); return; }
      if (!text) { note(r.input, "I didn't catch that. Tap the mic and try again"); return; }
      clearTimeout(r.input._phT); r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder; r.input.value = text;
      track('voice_ask', r.form.hasAttribute('data-ted-pdp') ? 'pdp' : 'chat');
      if (r.form.hasAttribute('data-ted-pdp')) pdpSubmit(r.form);
      else if (r.form.requestSubmit) r.form.requestSubmit(); else r.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
    if (blob.size < 1000) { done(''); return; }
    fetch(STT_URL, { method: 'POST', headers: { 'Content-Type': blob.type || 'audio/webm' }, body: blob })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { done((j && j.text) || ''); })
      .catch(function () { done(null); });
  }

  // ---------- Streaming a reply from the Worker ----------
  // opts: { messages, product, el (bubble), onDone(full) }
  function streamReply(opts) {
    var full = '', speech = voiceOn && TTS_URL ? startStream() : null;
    return fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(opts.product ? { messages: opts.messages, product: opts.product } : { messages: opts.messages }) })
      .then(function (r) {
        if (!r.ok || !r.body) throw new Error('status ' + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder();
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) return;
            full += dec.decode(res.value, { stream: true });
            var vis = visibleText(full);
            if (vis) { opts.el.className = opts.el.className.replace(' ted-typing', ''); opts.el.innerHTML = renderMd(vis); if (speech) speech.feed(vis, false); }
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (!full.trim()) throw new Error('empty');
        if (speech) speech.feed(visibleText(full), true); else if (voiceOn) speakDevice(visibleText(full));
        return full;
      })
      .catch(function (e) { if (speech) stopVoice(); throw e; });
  }

  // ---------- Chat window ----------
  function paint(who, html) {
    var el = document.createElement('div');
    el.className = 'ted-msg ted-msg--' + who; el.innerHTML = html;
    log.appendChild(el); log.scrollTop = log.scrollHeight;
    return el;
  }
  function bot(html) { history.push({ who: 'bot', html: html }); return paint('bot', html); }
  function setChips(list) {
    chips.innerHTML = '';
    (list || []).forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ted-chip'; b.textContent = c;
      b.addEventListener('click', function () { ask(c); });
      chips.appendChild(b);
    });
    save();
  }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ c: convo.slice(-38), h: history.slice(-40), open: !panel.hidden })); } catch (e) {} }
  function restore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!d || !d.h || !d.h.length) return false;
      convo = d.c || []; history = d.h;
      history.forEach(function (m) { paint(m.who, m.html); });
      return d.open;
    } catch (e) { return false; }
  }
  function welcome() {
    bot("Hi, I'm Ted, Tarpaulins UK's AI cover specialist. Tell me what you're covering, how big it is and how long it'll be outside, and I'll pick the right sheet and size for you.");
    setChips(["What weight for a winter outside?", "What size for my trailer?", "Cover for a roof leak", "Here are my sizes"]);
    suggestFor('', function (qs) { if (!convo.length) setChips(qs); });
  }
  function ask(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    if (!AI_URL) { bot('Our chat is offline right now. ' + TEAM); return; }
    if (convo.length >= 38) { bot('This conversation is getting long. Tap restart to start a fresh one, or call the team on <a href="' + TEL + '">' + PHONE + '</a>.'); return; }
    busy = true; unlockAudio();
    var userHtml = esc(text); history.push({ who: 'user', html: userHtml }); paint('user', userHtml);
    chips.innerHTML = '';
    var sent = !convo.length && document.title ? '[Customer is on the page: ' + document.title.replace(/\s+/g, ' ').slice(0, 120) + ']\n' + text : text;
    var msgs = convo.concat([{ role: 'user', content: sent }]);
    var el = paint('bot', '<span class="ted-dots"><i></i><i></i><i></i></span>'); el.className += ' ted-typing';
    statusEl.textContent = 'Ted is typing\u2026';
    streamReply({ messages: msgs, el: el }).then(function (full) {
      var out = renderReply(full, el);
      convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      out.done.then(function () { history.push({ who: 'bot', html: el.innerHTML }); save(); log.scrollTop = log.scrollHeight; });
      setChips(out.chips || []);
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { busy = false; statusEl.textContent = 'AI cover specialist \u00B7 replies in seconds'; save(); });
  }
  function open(msg, source) {
    var wasHidden = panel.hidden;
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); launch.classList.add('is-open');
    document.documentElement.classList.add('ted-is-open');
    requestAnimationFrame(function () { panel.classList.add('is-in'); });
    if (!log.children.length) welcome();
    if (wasHidden) track(msg ? 'ask' : 'open', source);
    if (window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { input.focus(); }, 30);
    if (msg) ask(msg);
    save();
  }
  function close() {
    stopVoice(); if (rec) { rec.silent = true; stopMic(); }
    panel.classList.remove('is-in'); panel.hidden = true;
    launch.setAttribute('aria-expanded', 'false'); launch.classList.remove('is-open');
    document.documentElement.classList.remove('ted-is-open');
    save();
  }
  function reset() { stopVoice(); convo = []; history = []; log.innerHTML = ''; chips.innerHTML = ''; welcome(); save(); }

  // Suggested questions written by the Worker for this page (cached at the edge).
  function suggestFor(handle, cb) {
    if (!BASE) return;
    var key = 'ted_sg_' + (handle || '_home');
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && c.length) { cb(c); return; } } catch (e) {}
    fetch(BASE + '/suggest' + (handle ? '?product=' + encodeURIComponent(handle) : ''), { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = j && j.questions;
        if (!list || list.length < 3) return;
        try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        cb(list);
      }).catch(function () {});
  }

  // ---------- "Questions about this product?" box on product pages ----------
  var PDP = null;
  function productHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function pdpChip(q) { return '<button type="button" class="ted-e__chip" data-ted-ask="' + esc(q) + '">' + esc(q) + '</button>'; }
  function pdpSave() { try { sessionStorage.setItem('ted_pdp_v1_' + (PDP.handle || '_home'), JSON.stringify({ c: PDP.convo.slice(-30), h: PDP.thread.innerHTML, ch: PDP.chips.innerHTML })); } catch (e) {} }
  function pdpSubmit(f) {
    var inp = f.querySelector('input'), q = inp && inp.value.trim();
    if (!q) { if (inp) inp.focus(); return; }
    inp.value = ''; pdpAsk(q);
  }
  function pdpAsk(q) {
    if (!PDP || PDP.busy || !q) return;
    if (!AI_URL) { open(q, 'pdp'); return; }
    if (PDP.convo.length >= 38) { PDP.convo = []; PDP.thread.innerHTML = ''; }
    PDP.busy = true; unlockAudio(); track('ask', PDP.handle ? 'pdp-expert' : 'home-hero');
    var userEl = document.createElement('div'); userEl.className = 'ted-e__msg ted-e__msg--user'; userEl.innerHTML = esc(q); PDP.thread.appendChild(userEl);
    var el = document.createElement('div'); el.className = 'ted-e__msg ted-e__msg--bot ted-typing'; el.innerHTML = '<span class="ted-dots"><i></i><i></i><i></i></span>'; PDP.thread.appendChild(el);
    if (PDP.handle) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); else PDP.thread.scrollTop = PDP.thread.scrollHeight;
    // The homepage panel has no product, so Ted answers as the general specialist; tell him where the customer is.
    var sent = !PDP.handle && !PDP.convo.length ? '[Customer is on the homepage, in the "Ask Ted" panel at the top]\n' + q : q;
    var msgs = PDP.convo.concat([{ role: 'user', content: sent }]);
    streamReply({ messages: msgs, product: PDP.handle, el: el }).then(function (full) {
      var out = renderReply(full, el);
      PDP.convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
      if (out.chips && out.chips.length) PDP.chips.innerHTML = out.chips.map(pdpChip).join('');
      out.done.then(pdpSave);
    }).catch(function () {
      el.innerHTML = "<p>Sorry, I couldn't get an answer just now. " + TEAM + '</p>';
    }).then(function () { PDP.busy = false; });
  }
  function mountProductBox() {
    var handle = productHandle();
    if (!handle || document.querySelector('.ted-e--pdp')) return;
    var buy = document.querySelector('form[action*="/cart/add"]:not([data-ted-skip])');
    if (!buy) return;
    // Sit straight under the buy buttons (Add to cart and its stock line), ahead of the trust, delivery and
    // add-on blocks the theme stacks below them. The box is a div, not a form, because it lands inside the
    // theme's product form, where a nested form's submit would reach the cart code.
    var pay = buy.querySelector('.product-form__payment-container, .shopify-payment-button');
    var anchor = pay && (pay.closest('.product-form__buy-buttons') || pay);
    if (anchor && !buy.contains(anchor)) anchor = null;
    anchor = anchor || buy.closest('.product-form') || buy;
    var box = document.createElement('section');
    box.className = 'ted-e ted-e--pdp';
    box.innerHTML = '<div class="ted-e__head"><span class="ted-e__icon" aria-hidden="true">T</span><div><div class="ted-e__title">Questions about this product?</div>' +
      '<div class="ted-e__sub">Ask Ted, our AI cover specialist. Answers in seconds, with the right size and price for your job.</div></div>' +
      '<button type="button" class="ted-e__voice" data-ted-voice aria-pressed="true">Voice on</button></div>' +
      '<div class="ted-e__thread" aria-live="polite"></div>' +
      '<div class="ted-e__chips">' + ['What size do I need?', 'Is this the right weight for my job?', 'How fast can I get it?'].map(pdpChip).join('') + '</div>' +
      '<div class="ted-e__form" data-ted-pdp><input type="text" enterkeyhint="send" maxlength="1000" placeholder="Ask anything about this tarpaulin\u2026" aria-label="Ask a question about this product">' + micButton() + '<button type="button" class="ted-e__send" data-ted-pdp-send>Ask</button></div>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    PDP = { box: box, handle: handle, thread: box.querySelector('.ted-e__thread'), chips: box.querySelector('.ted-e__chips'), convo: [], busy: false };
    try {
      var d = JSON.parse(sessionStorage.getItem('ted_pdp_v1_' + handle) || 'null');
      if (d && d.c) { PDP.convo = d.c; PDP.thread.innerHTML = d.h || ''; if (d.ch) PDP.chips.innerHTML = d.ch; }
    } catch (e) {}
    if (!PDP.convo.length) suggestFor(handle, function (qs) { if (!PDP.convo.length) PDP.chips.innerHTML = qs.map(pdpChip).join(''); });
    setVoice(voiceOn, false);
  }

  // ---------- Homepage "Ask Ted" hero (sections/ted-home-hero.liquid renders the shell) ----------
  // Same engine as the product box, with no product: Ted answers as the general specialist.
  function mountHomeHero() {
    var box = document.querySelector('[data-ted-home]');
    if (!box || PDP) return;
    var thread = box.querySelector('.ted-e__thread'), chipBox = box.querySelector('.ted-e__chips');
    var slot = box.querySelector('[data-ted-mic-slot]');
    if (slot) slot.outerHTML = micButton();
    PDP = { box: box, handle: '', thread: thread, chips: chipBox, convo: [], busy: false };
    try {
      var d = JSON.parse(sessionStorage.getItem('ted_pdp_v1__home') || 'null');
      if (d && d.c && d.c.length) { PDP.convo = d.c; thread.innerHTML = d.h || ''; if (d.ch) chipBox.innerHTML = d.ch; thread.scrollTop = thread.scrollHeight; }
    } catch (e) {}
    // Keep the newest words in view while a reply streams in, unless the customer has scrolled up to read.
    if (window.MutationObserver) {
      var pinned = true;
      thread.addEventListener('scroll', function () { pinned = thread.scrollHeight - thread.scrollTop - thread.clientHeight < 60; }, { passive: true });
      new MutationObserver(function () { if (pinned) thread.scrollTop = thread.scrollHeight; }).observe(thread, { childList: true, subtree: true, characterData: true });
    }
    setVoice(voiceOn, false);
  }

  // ---------- Wiring ----------
  function init() {
    var mic = document.getElementById('tedMicSlot');
    if (mic) mic.outerHTML = micButton();
    launch.hidden = false;
    launch.addEventListener('click', function () { panel.hidden ? open(null, 'launcher') : close(); });
    document.getElementById('tedClose').addEventListener('click', close);
    document.getElementById('tedRestart').addEventListener('click', reset);
    form.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (!q) { input.focus(); return; } input.value = ''; ask(q); });
    document.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-ted-voice]');
      if (vb) { e.preventDefault(); setVoice(!voiceOn, vb.closest('.ted-e') ? 'pdp' : 'chat'); return; }
      var m = e.target.closest('.ted-mic');
      if (m) { e.preventDefault(); var f = m.closest('form, [data-ted-pdp]'); if (f && !m.classList.contains('is-busy')) { unlockAudio(); startMic(f); } return; }
      var c = e.target.closest('[data-ted-ask]');
      if (c) { e.preventDefault(); pdpAsk(c.getAttribute('data-ted-ask')); return; }
      var send = e.target.closest('[data-ted-pdp-send]');
      if (send) { e.preventDefault(); pdpSubmit(send.closest('[data-ted-pdp]')); return; }
      var add = e.target.closest('.ted-add');
      if (add) { e.preventDefault(); addToCart(add); return; }
      var opener = e.target.closest('[data-ted-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-ted-open') || null, 'link'); }
    });
    // The product box has no form of its own, so Enter is handled here and never reaches the theme's
    // product form (where it would add to basket).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var f = e.target.closest && e.target.closest('[data-ted-pdp]');
      if (f) { e.preventDefault(); e.stopPropagation(); pdpSubmit(f); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    if (restore()) open(null, 'restore');
    setVoice(voiceOn, false);
    mountProductBox();
    mountHomeHero();
    window.TedChat = { open: function (q) { open(q || null, 'api'); }, close: close, toggle: function () { panel.hidden ? open(null, 'api') : close(); } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
